module.exports = __webpack_public_path__ + "static/media/blog.a2d7ed1d.svg";